/* ZZEN DS · listicle Pelo
   Razón 1: el último párrafo («10 nutrientes · 4 ingredientes patentados · 2 cápsulas») se parte
   por «·» en pastillas. El texto sigue editándose en el editor; las pastillas salen de ahí. */
(function () {
  function pills() {
    document.querySelectorAll('#hx-b-imagen_texto_2 .hx-rte > p:last-child').forEach(function (p) {
      if (p.classList.contains('zz-pills') || p.textContent.indexOf('·') === -1) return;
      var items = p.textContent.split('·').map(function (t) { return t.trim(); }).filter(Boolean);
      p.textContent = '';
      items.forEach(function (t) {
        var s = document.createElement('span');
        s.className = 'zz-pill';
        s.textContent = t;
        p.appendChild(s);
      });
      p.classList.add('zz-pills');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pills);
  else pills();
  document.addEventListener('shopify:section:load', pills);
})();
